import { AbstractControl } from '@angular/forms';

export class KeyCustomPropertyValidator {
  static checkBlockedCharacters() {
    return (
      control: AbstractControl
    ): { containBlockedCharacters: boolean } | null => {
      const BLOCKED = [
        '.',
        '!',
        '@',
        '#',
        '$',
        '%',
        '&',
        '*',
        '(',
        ')',
        '[',
        ']',
        '`',
        '"',
        '|',
        '<',
        '>',
        ':',
        ',',
        '-',
        '_',
        "'",
      ];

      if (control.value) {
        const value = control.value as string;

        const found = [...value].some((el) => BLOCKED.includes(el));

        if (found) {
          return {
            containBlockedCharacters: true,
          };
        }
      }

      return null;
    };
  }
}
